const TextItalicIcon = /*#__PURE__*/ [
  ["path", { d: "M12 4H19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 20L16 4", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 20H12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export { TextItalicIcon as default };
//# sourceMappingURL=TextItalicIcon.js.map
